// extracted by mini-css-extract-plugin
module.exports = {"content":"ForgotPassword_content__lzulK","submit":"ForgotPassword_submit__3eFlj","policy":"ForgotPassword_policy__1OiYl","errorMsg":"ForgotPassword_errorMsg__1nX9k"};